const FullPageLoader = () => {
  return (
    <div className="position-fixed top-0 start-0 fullpage-loader bottom-0 w-100 h-100 d-flex justify-content-center align-items-center ">
      <div className="spinner-border text-primary p-4" role="status"></div>
    </div>
  );
};
export default FullPageLoader;
